module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/General/Lock-f4c85e5a09ce182d8ebbdaf2f0ba52dd.svg";